export default {
  env (test) {
    let env = null

    if (location.hostname === 'localhost' || location.hostname.endsWith('devis-b2b.d')) {
      env = 'local'
    } else if (location.hostname.endsWith('staging.devis-b2b.com')) {
      env = 'staging'
    } else {
      env = 'production'
    }

    if(test) {
      return test === env
    } else {
      return env
    }
  },
  url (endpoint, resource) {
    let protocol = location.protocol === 'https:' === 'https:' ? 'https' : 'http'
    let tld = null

    if(this.env('local')) {
      tld = 'devis-b2b.d'
    } else if(this.env('staging')) {
      tld = 'staging.devis-b2b.com'
    } else {
      tld = 'devis-b2b.com'
    }

    return protocol + '://' + endpoint + '.' + (tld + '/' + resource).replace('//', '/')
  }
}



//////////////////
// WEBPACK FOOTER
// ./libs/@db2b/nexus-js-v1/helper.js
// module id = 20
// module chunks = 1